<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0" class="padding20 local-anesthesia" style="padding-top: 0px">
        <el-row style="margin-left: 20px">
            <el-col :span="activeAnesConfigIndex > 0 ? 18 : 24" class="align-left">
                <div v-for="(item, index) in this.localAnesConfig" :key="index" style="display: inline-block; margin-right: 5px; margin-top: 20px; text-align: center">
                    <el-button type="primary" :disabled="(item.event && item.event.occur_time != ``) || !canEdit" size="mini" @click="saveOccurEvent(index, item)" style="width: 175px">
                        {{ item.label }}
                    </el-button>
                    <div class="local-anesthesia-date" v-show="showDatetime">
                        <item-input
                            v-if="item.event.occur_time == ``"
                            type="string"
                            readonly="readonly"
                            v-model="item.event.occur_time"
                            style="width: 175px; height: 40px; margin-top: 5px"
                            datetimeFormate="HH:mm"
                        ></item-input>
                        <!-- <item-input
                            v-if="item.event.occur_time != ``"
                            type="datetime"
                            v-model="item.event.occur_time"
                            style="width: 80px"
                            datetimeFormate="HH:mm"
                            @input="changeOccurTime(item)"
                        ></item-input> -->
                        <input
                            class="inputlocal"
                            :readonly="isHavejustKey == false ? true : false"
                            v-if="item.event.occur_time != ``"
                            v-model="item.event.local_occur_time"
                            type="datetime-local"
                            name="points"
                            max="2299-01-01T23:59"
                            @blur="changeOccurTime(item)"
                        />
                    </div>
                </div>
            </el-col>
            <el-col :span="activeAnesConfigIndex > 0 ? 6 : 0" class="align-right padding-right20">
                <el-button
                    type="primary"
                    size="mini"
                    v-if="activeAnesConfigIndex > 0 && surgeryInfo.enum_surgery_status > 30 && surgeryInfo.enum_surgery_type == 1 && this.havePermissionMerge && canEdit"
                    @click="loadMergedPatientData"
                    class="hidden-md-and-down"
                    style="margin-top: 20px"
                    ><span class="el-icon-folder-checked"></span><span>手术合并</span></el-button
                >

                <el-button
                    style="margin-top: 20px"
                    type="primary"
                    size="mini"
                    v-if="activeAnesConfigIndex > 0 && this.havePermissionCancel && canEdit"
                    @click="cancelLocalAnesSurgery"
                    class="hidden-md-and-down"
                    ><span class="el-icon-document-delete"></span><span>误入手术</span></el-button
                >
                <el-button
                    style="margin-top: 20px"
                    type="primary"
                    circle
                    size="mini"
                    v-if="activeAnesConfigIndex > 0 && this.havePermissionCancel && canEdit"
                    @click="cancelLocalAnesSurgery"
                    class="hidden-lg-and-up"
                    title="误入手术"
                    ><span class="el-icon-document-delete"></span
                ></el-button>
                <el-button style="margin-top: 20px" type="primary" size="mini" v-if="activeAnesConfigIndex > 0 && canEdit" @click="saveSurgeryInfo" class="hidden-md-and-down"
                    ><span class="iconfont icon-baocun-xian"></span><span>&nbsp;保存</span></el-button
                >
                <el-button style="margin-top: 20px" type="primary" circle size="mini" v-if="activeAnesConfigIndex > 0 && canEdit" @click="saveSurgeryInfo" class="hidden-lg-and-up" title="保存"
                    ><span class="iconfont icon-baocun-xian"></span
                ></el-button>
            </el-col>
        </el-row>
        <el-row style="margin-left: 20px">
            <el-col :span="24" class="align-left">
                <div class="align-left line-height24 inline">
                    <div v-for="item in this.monitor_datas" :key="item.physio_param.id" style="display: inline-block; margin-right: 5px">
                        {{ item.physio_param.alias || item.physio_param.name }}：<br />
                        <b :class="{ 'fg-danger': item.is_warning }">{{ item.value }}</b>
                    </div>
                </div>
            </el-col>
        </el-row>
        <cus-form ref="surgery-info" :data="surgeryInfo" :columns="basicInfoColumnList" style="margin-top: 20px" @confirm="putOne"></cus-form>
        <el-row>
            <el-col :md="24" :xl="24" v-show="this.surgeryInfo.enum_surgery_status >= 30" v-has-permission="factSurgeryShowPermission">
                <div class="padding10">
                    <el-card :body-style="{ padding: '5px' }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"
                                ><h3 class="margin20 margin-none-v">
                                    已施手术<i @click="drawer.playedsurgeryInfo = !drawer.playedsurgeryInfo" :class="drawer.playedsurgeryInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                                </h3>
                            </el-col>
                            <el-col :span="8" class="align-right padding20 padding-none-v"
                                ><el-button type="warning" size="mini" v-if="activeAnesConfigIndex > 0 && canEdit" @click="playedsurgeryInfoSaveSueryInfo">保存</el-button></el-col
                            >
                        </el-row>
                        <div class="playedsurgery" v-show="drawer.playedsurgeryInfo">
                            <cus-form ref="played-surgery-info" :data="surgeryInfo" :columns="playedsurgeryInfoColumnList" @extrabutton-click="ExtraButtonClick" @confirm="savePlayedSurgery">
                            </cus-form>
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <el-dialog title="合并手术" :visible.sync="mergeApplyList.dialogFormVisible" class="table-h460" :close-on-click-modal="false" width="90%">
            <crud-facecade
                ref="merge-list"
                :url="mergeApplyList.data"
                :columns="mergeColunmList"
                :buttons="buttons"
                :addButton="{ enabled: false }"
                :updateButton="{ enabled: false }"
                @rowClick="activTargetRow"
            >
                <template slot="filter">
                    <el-col :span="4">
                        <item-input type="datearraw2" v-model="rdate1" :clearable="false" size="mini"></item-input>
                    </el-col>
                </template>
                <div slot="table-title" class="align-left padding5" v-show="mergedRow !== undefined">
                    <b>患者姓名:</b> {{ mergedRow && mergedRow.name }} &nbsp; <b>病历号:</b>{{ mergedRow && mergedRow.visit_no }} &nbsp; <b>性别:</b
                    >{{ mergedRow && mergedRow.visit_info && mergedRow.visit_info.sex }} &nbsp; <b>年龄:</b>{{ mergedRow && mergedRow.age }} &nbsp; <b>科室:</b
                    >{{ mergedRow && mergedRow.dic_section }} &nbsp; <b>拟施手术:</b>{{ mergedRow && mergedRow.surgeries }} &nbsp;
                </div>
            </crud-facecade>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelMerge">取 消</el-button>
                <el-button type="primary" @click="merged">确 定</el-button>
            </span>
        </el-dialog>
        <DateTimeInput @changetime="changetime" :visible.sync="timeInfo.dialogFormVisible" :timedata="timeInfo.timedata"></DateTimeInput>
        <form-dialog :title="overrule.title" :data="overrule.data" :visible.sync="overrule.dialogFormVisible" :columns="overrule.columns" @confirm="saveOverrule"></form-dialog>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
    name: `OutRoomAnes`,
    props: {},
    data() {
        let validateLength = (rule, value, callback) => {
            if (value && value.trim().length < 4) {
                callback(new Error(`终止理由不能少于4个字符`))
            } else {
                callback()
            }
        }
        return {
            title: `室外麻醉`,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            isAllowAdjustKeyEvent: this.$root.IsAllowAdjustKeyEvent,
            surgeryId: this.$route.query.surgery_id,
            surgeryInfo: {},
            oldSurgeryInfo: {},
            dataChanged: false,
            localAnesConfig: [],
            timeInfo: {
                timedata: this.$moment().format(`YYYY/MM/DD HH:mm`),
                dialogFormVisible: false
            },
            showDatetime: false,
            activeAnesConfigIndex: -1,
            occurdt: this.$moment().format(`YYYY/MM/DD HH:mm`),
            occurEvents: [],
            monitor_datas: [],
            rdate1: this.$moment().format(`YYYY/MM/DD`),
            mergeApplyList: {
                dialogFormVisible: false,
                data: {
                    baseURL: `/api/Preoperative/Apply/GetForMergeList`,
                    get: () => {
                        return new Promise((resolve, reject) => {
                            let that = this
                            let req = that.myaxios.get(`/api/Preoperative/Apply/GetForMergeList?date=${this.rdate1}`)
                            req.then(data => {
                                resolve(data)
                            }).catch(e => reject(e))
                        })
                    }
                }
            },
            mergedRow: undefined,
            merged_target_row: undefined,
            buttons: [],
            factSurgeryShowPermission: `baseInfo:fact_surgery_manager`, // 实际手术卡片显示隐藏
            required: this.$root.FactSurgerieRequires && this.$root.FactSurgerieRequires.split(`|`) || [],
            showModifySurgeryMode: this.$root.ShowModifySurgeryMode === `0` ? 1 : 2,
            drawer: {
                playedsurgeryInfo: true // 控制用户信息页签折叠和展开
            },
            checkCutLevel: this.$root.CheckCutLevel || `0`,
            showFactColumns: this.$root.ShowFactColumns && this.$root.ShowFactColumns.split(`|`) || [],
            overrule: {
                title: `手术终止`,
                dialogFormVisible: false,
                data: {},
                surgeryId: 0,
                columns: [
                    {
                        type: `string`,
                        prop: `term_reason`,
                        label: `终止原因`,
                        config: {
                            allowCreate: true
                        },
                        validate: [
                            { validator: validateLength, trigger: `blur` },
                            { required: true, message: `必填项目`, trigger: `blur` }
                        ]
                    }
                ]
            },
            czevent: {},
            havePermissionTermination: false,
            havePermissionCancel: false,
            havePermissionMerge: false,
            // drugsBeforeAnes:[]
            canEditSurgeryScale: this.$root.CanEditSurgeryScale,
            enum_businesstype: -1,
            activeIndex: -1,
            eventConfig: []
        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
        this.dataChanged = false
    },
    mounted() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
        this.init()
        clearInterval(this.interval)
        this.interval = setInterval(() => {
            this.loadMonitorDatas()
        }, 10000)
        // 手术终止权限
        this.havePermissionTermination = this.IsHavePermission(`local_anesthesia_termination`)
        // 误入取消权限
        this.havePermissionCancel = this.IsHavePermission(`local_anesthesia_cancel`)
        // 手术合并权限
        this.havePermissionMerge = this.IsHavePermission(`local_anesthesia_merge`)
    },
    computed: {
        ...mapGetters([`screenHeight`, `surgery/visit_type`, `surgery/anaesthesia_method`, `operation_room_auth`, `section_auth`, `operation_ward_auth`, `permissions`, `sys_enums`, `sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`, `otherSettingColumn`,
            `extendColumnList`]),
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        isHavejustKey() {
            let adjustKeyEvent = this.IsHavePermission(`Desltop:AdjustKeyEvent`)
            if (adjustKeyEvent) {
                return true
            } return false
        },
        canEdit() {
            // 手术麻醉单归档后不能在保存
            let caneditarchived = this.IsHavePermission(`dic_surgery_caneditarchived`)
            if (caneditarchived) {
                return true
            } else {
                return !this.surgeryInfo.is_archived
            }
        },
        basicInfoColumnList() {
            let factSurgeryShow = this.IsHavePermission(`baseInfo:fact_surgery_manager`)
            let status = this.surgeryInfo.enum_surgery_status
            let me = this
            let list = [
                {
                    type: `p`,
                    prop: `title1`,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `p`,
                    prop: `title2`,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`local_anesthesia.visit_no`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `姓名`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `card_no`,
                    label: `身份证`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_sex`,
                    label: `性别`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: this.sys_enums.Enum_Sex || []
                },
                {
                    type: `date`,
                    prop: `birthday`,
                    label: `出生日期`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    change: (that, { row }) => {
                        let bir = row.birthday
                        let currentDate = this.$moment()
                        let birthDate = this.$moment(bir || ``)
                        let age = this.$moment.duration(currentDate.diff(birthDate))._data
                        row.age = age.years == 0 ? (age.months == 0 ? `${age.days}天` : `${age.months}月`) : `${age.years}岁`
                    }
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `height`,
                    label: `身高(cm)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 3
                },
                {
                    type: `string`,
                    prop: `weight`,
                    label: `体重(kg)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 3
                },
                {
                    type: `select`,
                    prop: `enum_blood_type`,
                    label: `血型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_BloodType || [],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_rh_blood_type`,
                    label: `RH`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_RhBloodType || [],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgeryType || [],
                    colspan: 6,
                    default: 1
                },
                {
                    type: `select`,
                    prop: `enum_asa`,
                    label: `ASA`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_ASA || [],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `科室`,
                    isCreatable: true,
                    isEditable: true,
                    options: this[`section_auth`],
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `drug_before_anes`,
                    label: `麻前用药`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_DrugBeforeAnes,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `is_fasting`,
                    label: `术前禁食`,
                    isCreatable: true,
                    isEditable: true,
                    options: `enum_bool`,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `surgical_site`,
                    label: `手术部位`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgicalSite || [],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `surgery_position`,
                    label: `手术体位`,
                    isCreatable: true,
                    isEditable: true,
                    options: [
                        { label: `仰卧位`, value: 1 },
                        { label: `俯卧位`, value: 2 },
                        { label: `左侧卧位`, value: 3 },
                        { label: `右侧卧位`, value: 4 },
                        { label: `截石位`, value: 5 },
                        { label: `屈式位`, value: 6 },
                        { label: `其他`, value: 9 }
                    ],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_cut_level`,
                    label: `切口等级`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_CutLevel || [],
                    colspan: 6,
                    change: (that, { row }) => {
                        if (me.checkCutLevel && me.checkCutLevel == `1` && row.enum_cut_level == 1) {
                            me.$alert(`<strong>请确认是否I类手术切口</strong>`, `提示`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `inductive_effect`,
                    label: `诱导效果`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_InductionEffect || [],
                    colspan: 3
                },
                {
                    type: `select`,
                    prop: `inductive_complication`,
                    label: `诱导并发症`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_InducedComplication || [],
                    colspan: 3
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_diseases`,
                    label: `术前诊断`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: `/api/AcisSystem/Disease/Search`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_diseases`,
                    label: `术后诊断`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: `/api/AcisSystem/Disease/Search`
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_surgeries`,
                    label: `拟施手术`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: `/api/AcisSystem/Surgery/Search`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_surgeries`,
                    label: `已施手术`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    readonly: status >= 30 && factSurgeryShow,
                    colspan: 12,
                    options: `/api/AcisSystem/Surgery/Search`
                },
                {
                    type: `p`,
                    prop: `plan`,
                    label: { content: `计划:` },
                    isEditable: true,
                    field_style: `font-weight:bold;text-align:left;text-align-last:left;margin-top:-10px;margin-bottom: 2px;`,
                    colspan: 24
                },
                {
                    type: `remoteselect`,
                    prop: `plan_surgeon`,
                    label: this.T(`surgeryinfo.plan_surgeon`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 4,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }

                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_surgeon_assistants`,
                    label: this.T(`surgeryinfo.plan_surgeon_assistants`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 4,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))
                            if (this.$root.UseASACheck == `1`) {
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })

                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    config: {
                        collapseTags: false,
                        multipleLimit: 2
                    }
                },
                {

                    type: `remoteselect`,
                    prop: `plan_anes_doctor`,
                    label: this.T(`surgeryinfo.plan_anes_doctor`),
                    isCreatable: true,
                    ref: `doctor`,
                    isEditable: true,
                    colspan: 4,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }

                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    }// ,
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_anes_assistants`,
                    label: this.T(`surgeryinfo.plan_anes_assistants`),
                    colspan: 4,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))
                            if (this.$root.UseASACheck == `1`) {
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })

                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    config: {
                        collapseTags: false,
                        multipleLimit: 2
                    }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_circuit_nurse`,
                    label: this.T(`surgeryinfo.plan_circuit_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    config: {
                        collapseTags: false,
                        multipleLimit: 2
                    },
                    colspan: 4
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`local_anesthesia.fact_equipment_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    config: {
                        collapseTags: false,
                        multipleLimit: 2
                    },
                    colspan: 4
                },
                {
                    type: `p`,
                    prop: `fact`,
                    label: { content: `实际:` },
                    isEditable: true,
                    field_style: `font-weight:bold;text-align:left;text-align-last:left;margin-top:-10px;margin-bottom: 2px;`,
                    colspan: 24
                },
                {
                    type: `remoteselect`,
                    prop: `fact_surgeon`,
                    label: this.T(`surgeryinfo.plan_surgeon`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 4,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }

                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    }
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_surgeon_assistants`,
                    label: this.T(`surgeryinfo.plan_surgeon_assistants`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 4,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))
                            if (this.$root.UseASACheck == `1`) {
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })

                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    config: {
                        collapseTags: false,
                        multipleLimit: 2
                    }
                },
                {

                    type: `remoteselect`,
                    prop: `fact_anes_doctor`,
                    label: this.T(`surgeryinfo.plan_anes_doctor`),
                    isCreatable: true,
                    ref: `doctor`,
                    isEditable: true,
                    colspan: 4,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }

                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    }// ,
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {

                    type: `remotemultiselect`,
                    prop: `fact_anes_assistants`,
                    label: this.T(`surgeryinfo.plan_anes_assistants`),
                    colspan: 4,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))
                            if (this.$root.UseASACheck == `1`) {
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })

                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    config: {
                        collapseTags: false,
                        multipleLimit: 2
                    }
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_circuit_nurse`,
                    label: this.T(`surgeryinfo.plan_circuit_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    config: {
                        collapseTags: false,
                        multipleLimit: 2
                    },
                    colspan: 4
                },
                {
                    type: `remotemultiselect`,
                    prop: `fact_equipment_nurse`,
                    label: this.T(`local_anesthesia.fact_equipment_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    config: {
                        collapseTags: false,
                        multipleLimit: 2
                    },
                    colspan: 4
                },
                {
                    type: `select`,
                    prop: `enum_pay_type`,
                    label: `费用类别`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_PayType || [],
                    colspan: 12
                },
                {
                    type: `multiselect`,
                    prop: `fact_anaes_methods`,
                    label: `麻醉方式`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: this[`surgery/anaesthesia_method`],
                    config: {
                        collapseTags: false
                    },
                    colspan: 12
                },
                {
                    type: `textarea`,
                    prop: `plan_emergency_remark`,
                    label: `术前特殊情况描述`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    config: {
                        minRows: 1
                    }
                }, {
                    type: `select`,
                    prop: `enum_out_room_destination`,
                    label: `患者去向`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_OutRoomDestination || [],
                    colspan: 12
                }, {
                    type: `select`,
                    prop: `enum_outoperatingroomtype`,
                    label: `室外麻醉分类`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_OutOperatingRoomType || [],
                    colspan: 12,
                    readonly: (that, { row }) => {
                        return this.activeAnesConfigIndex > 0
                    }
                }
            ]
            // 分组的列单独渲染，未分组的放到手术申请基本信息栏
            let r = _.cloneDeep(this.extendColumnList)
            r = _.filter(r, d => {
                return ((d.data_group_name == null || d.data_group_name == ``) && (d.basic_group_name == null || d.basic_group_name == ``)) || d.basic_group_name == `基本信息`
            }).sort((a, b) => a.display_order - b.display_order)
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(
                r,
                list
            )
            list = _.filter(list, function(d) {
                return d.isEditable === true
            })
            if (this.extendColumnList) {
                this.listextends = this.$surgeryInfoExtraParamUtil.SetExtraColumnListToEdit(this.extendColumnList)
            }
            return list
        },
        mergeColunmList() {
            return [
                {
                    type: `string`,
                    label: `序号`,
                    prop: `id`,
                    isListable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    label: this.T(`anesthesia_surgery_list.visit_no`),
                    prop: `visit_no`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `门诊号`,
                    prop: `outpatient_no`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `姓名`,
                    prop: `patient_name`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `性别`,
                    prop: `sex`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `年龄`,
                    prop: `age`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `拟施手术`,
                    prop: `surgeries`,
                    isListable: true
                }
            ]
        },
        playedsurgeryInfoColumnList() {
            let showMode = this.showModifySurgeryMode
            let table = [
                {
                    type: `table2`,
                    prop: `fact_surgery_items`,
                    label: ``,
                    isEditable: true,
                    isCreatable: true,
                    options: [{
                        type: `string`,
                        prop: `id`,
                        label: `id`,
                        area: [1, 2],
                        isKey: true
                    },
                    {
                        type: `string`,
                        prop: `prefix_name`,
                        label: `前缀`,
                        isListable: true,
                        readonly: false,
                        area: [1],
                        colspan: 2
                    },
                    {
                        type: `string`,
                        prop: `icd_code`,
                        label: this.T(`surgery.code`),
                        isListable: true,
                        readonly: true,
                        area: [2],
                        colspan: 2
                    },
                    {
                        type: `remoteselect`,
                        prop: `plan_surgeries`,
                        label: showMode == 2 ? `ICD手术名称` : `手术名称`,
                        showCount: 1,
                        isListable: true,
                        readonly: false,
                        colspan: 4,
                        area: [1, 2],
                        options: `/api/AcisSystem/Surgery/SearchIncludOpeLevel`,
                        change: (that, { row, area }) => {
                            if (row.is_empty) {
                                this.$set(row, `is_empty`, false)
                                this.surgeryInfo.fact_surgery_items.push({ is_empty: true })
                            }
                            if (_.isEmpty(row.plan_surgeries)) {
                                row.plan_surgery_scale = undefined
                            } else {
                                var max = -1
                                try {
                                    if (row.plan_surgeries.description) {
                                        let level = parseInt(row.plan_surgeries.description)
                                        if (level > max) { max = level }
                                    }
                                } catch (err) {
                                    console.log(err)
                                }
                                if (max > 0) {
                                    row.plan_surgery_scale = max
                                } else {
                                    row.plan_surgery_scale = undefined
                                }
                            }
                            if (showMode == 2) {
                                this.$set(row, `icd_code`, row.plan_surgeries.code)
                                this.$set(row, `plan_surgeries_name`, row.plan_surgeries.label)
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]

                    },
                    {
                        type: `string`,
                        prop: `plan_surgeries_name`,
                        label: `实际手术名称`,
                        isListable: true,
                        readonly: false,
                        config: { clearable: false },
                        area: [2],
                        width: 250,
                        colspan: 4
                    },
                    {
                        type: `string`,
                        prop: `behind_name`,
                        label: `后缀`,
                        isListable: true,
                        readonly: false,
                        area: [1],
                        colspan: 2
                    },
                    {
                        type: `select`,
                        prop: `plan_surgery_scale`,
                        label: `手术等级`,
                        isListable: true,
                        readonly: !(!this.$root.CanEditSurgeryScale || this.$root.CanEditSurgeryScale == `1`),
                        area: [1, 2],
                        options: this.sys_enums.Enum_SurgeryScale || [],
                        colspan: 2,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `select`,
                        prop: `plan_enum_cut_level`,
                        label: `切口等级`,
                        isListable: true,
                        readonly: false,
                        options: this.sys_enums.Enum_CutLevel || [],
                        colspan: 2,
                        area: [1, 2],
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `select`,
                        prop: `plan_surgery_region`,
                        label: `部位`,
                        isCreatable: true,
                        isListable: true,
                        readonly: false,
                        options: this.sys_enums.Enum_Region || [],
                        colspan: 3,
                        area: [1, 2],
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `select`,
                        prop: `plan_surgery_position`,
                        label: `体位`,
                        isCreatable: true,
                        isListable: true,
                        readonly: false,
                        area: [1, 2],
                        options: this.sys_enums.Enum_Position || [],
                        colspan: 3
                    },
                    {
                        type: `select`,
                        prop: `plan_anaes_method`,
                        label: `麻醉方式`,
                        isListable: true,
                        readonly: false,
                        area: [1, 2],
                        options: (that, { row }) => {
                            return _.filter(this[`surgery/anaesthesia_method`], function(i) { return (i.enum_dic_type === 1 || i.enum_dic_type === 2) })
                        },
                        colspan: 3
                    },
                    {
                        type: `buttongroup`,
                        prop: `oper`,
                        label: `操作`,
                        width: `60`,
                        isListable: true,
                        fixed: `right`,
                        readonly: false,
                        area: [1, 2],
                        colspan: 2,
                        options: (that, { row }) => {
                            return row.is_empty || !row.plan_surgeries
                                ? []
                                : [
                                    {
                                        class: `is-plain is-circle`,
                                        label: ``,
                                        icon: `el-icon-close`,
                                        type: `danger`,
                                        emit: `removeItem`,
                                        permission: `default`
                                    }
                                ]
                        }
                    }
                    ],
                    colspan: 24,
                    default: [{
                        is_empty: true
                    }]
                }
            ]
            let cols = _.filter(table[0].options, d => {
                return d.area.indexOf(showMode) > -1
            })

            let baseCols = [`手术等级`, `切口等级`, `部位`, `体位`, `麻醉方式`]
            let cols2 = _.filter(cols, d => {
                return _.find(baseCols, f => f == d.label) == undefined || (_.find(baseCols, f => f == d.label) != undefined && _.find(this.showFactColumns, f => f == d.label) != undefined)
            })
            table[0].options = cols2
            return table
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        }
    },
    methods: {
        init() {
            if (this.surgeryId > 0) {
                return new Promise((resolve, reject) => {
                    this.loadOne().then(data => {
                        resolve(data)
                    }).catch(e => {
                        console.log(e)
                        reject(e)
                    })
                })
            }
        },
        loadMonitorDatas() {
            if (this.surgeryInfo && this.surgeryInfo.dic_operating_room_id && this.surgeryInfo.enum_surgery_status == 30) {
                return new Promise((resolve, reject) => {
                    let clientIp = sessionStorage.getItem(`clientIp`)
                    if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                        clientIp = ``
                    }

                    let token = sessionStorage.getItem(`token`)
                    let authorization = `bearer ${token}`
                    if (!token || token === `undefined` || token === `null`) {
                        authorization = undefined
                    }
                    // 改成原始的axios请求方式，避免 加载中，请稍等..... 模态窗导致界面卡顿
                    let req = axios.get(`/api/Operation/Monitor/OperationMonitor?operatingRoomId=${this.surgeryInfo.dic_operating_room_id}`, Object.assign({ headers: {
                        'Authorization': authorization,
                        'clientIp': clientIp
                    },
                    emulateJSON: true }))
                    req.then(response => {
                        if (_.has(response, `status`)) {
                            if (response.status === 200) {
                                this.monitor_datas = response.data.monitor_datas
                                console.log(`定时10s 体征数据`)
                                resolve(this.monitor_datas)
                            } else {
                                return reject(response.msg)
                            }
                        } else {
                            resolve(response)
                        }
                    }).catch(e => {
                        console.log(e, 1)
                        reject(e)
                    })
                })
            }
        },
        changeOccurTime(item) {
            let oldtime = this.$moment(item.event.occur_time).format(`YYYY/MM/DD HH:mm`)
            let newtime = this.$moment(item.event.local_occur_time).format(`YYYY/MM/DD HH:mm`)
            console.log(oldtime)
            console.log(newtime)
            if (oldtime == newtime) {
                return
            }
            item.event.occur_time = this.$moment(item.event.local_occur_time).format(`YYYY/MM/DD HH:mm`)
            this.myaxios[item.event.id ? `put` : `post`](`/api/Intraoperative/Anaesthesia/${item.event.id ? `PutOccurEvent` : `PostOccurEvent`}`, item.event)
                .then(data => {
                    // this.$message.success(`${item.label}时间已修改`)
                    this.init().then(data => {
                        let tmpSurgeryInfo = { ...data }
                        tmpSurgeryInfo.surgery_status = _.filter(this.sys_enums.SurgeryStatus, { value: tmpSurgeryInfo.enum_surgery_status })[0].label
                        this.$emit(`changeSurgeInfo`, tmpSurgeryInfo)
                    }).catch(e => {
                        console.log(e)
                        this.$message.error(e)
                    })
                })
                .catch(e => console.log(e))
        },
        loadBusinessConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/OtherBusiness/BusinessKeyEventConfig/GetConfig?enum_businesstype=${this.enum_businesstype}`)
                let req2 = this.myaxios.get(`/api/OtherBusiness/BusinessOccurEvent/GetBusinessOccurEvent?surgeryInfoId=${this.surgeryId}&enum_businesstype=${this.enum_businesstype}`)
                this.myaxios.all(req, req2).then(([config, events]) => {
                    console.log(`a`, config)
                    console.log(`b`, events)
                    this.activeAnesConfigIndex = events.length
                    this.localAnesConfig = _.map(config, d => {
                        let et = _.find(events, evt => evt.dic_event_id == d.value)
                        d.event = (et && {
                            id: et.id,
                            dic_event_id: d.value,
                            biz_surgery_info_id: this.surgeryId,
                            enum_business_type: this.enum_businesstype,
                            occur_time: et.occur_time,
                            local_occur_time: that.timeForm(et.occur_time)
                        }) || {
                            dic_event_id: d.value,
                            biz_surgery_info_id: this.surgeryId,
                            enum_business_type: this.enum_businesstype,
                            occur_time: ``
                        }
                        return d
                    })
                    console.log(`c`, this.localAnesConfig)
                    resolve()
                })
            })
        },
        loadOne() {
            this.showDatetime = false
            if (!this.surgeryId) return
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                req.then(data => {
                    let datas = _.reduce(
                        data.extra_datas,
                        function(result, value, index) {
                            result[value.DataKey] = value.DataValue
                            return result
                        },
                        {}
                    )
                    let obj = Object.assign(
                        {
                            id: data.id,
                            is_archived: data.is_archived, // 手术对应的麻醉单是否已归档
                            title1: `　患者信息`,
                            title2: `　手术信息`,
                            plan_time: data.plan_time,
                            infectious: data.infectious && data.infectious.split(`,`),
                            is_fasting: data.is_fasting,
                            localAnes: data.is_local_anes,
                            remark: data.remark,
                            enum_asa: data.enum_asa,
                            enum_surgery_status: data.enum_surgery_status,
                            enum_surgery_scale: data.enum_surgery_scale,
                            enum_surgery_type: data.enum_surgery_type,
                            dic_section_id: data.dic_section_id,
                            dic_section: data.dic_section,
                            dic_operating_room_id: data.dic_operating_room_id,
                            dic_operating_ward_id: data.dic_operating_ward_id,
                            enum_isolation_status: data.enum_isolation_status,
                            enum_cut_level: data.enum_cut_level,
                            enum_out_room_destination: data.enum_out_room_destination,
                            enum_outoperatingroomtype: data.enum_outoperatingroomtype,
                            age: data.visit_info.age,
                            height: data.visit_info.height,
                            weight: data.visit_info.weight,
                            bed_no: data.visit_info.bed_no,
                            visit_no: data.visit_info.visit_no,
                            outpatient_no: data.visit_info.outpatient_no,
                            visit_time: data.visit_info.visit_time,
                            phone: data.visit_info.phone,
                            address: data.visit_info.address,
                            enum_visit_type: data.visit_info.enum_visit_type,
                            enum_pay_type: data.visit_info.enum_pay_type,
                            name: data.visit_info.name,
                            birthday: data.visit_info.birthday,
                            card_type: data.visit_info.card_type,
                            card_no: data.visit_info.card_no,
                            insurance_no: data.visit_info.insurance_no,
                            enum_blood_type: data.visit_info.enum_blood_type,
                            enum_rh_blood_type: data.visit_info.enum_rh_blood_type,
                            enum_sex: data.visit_info.enum_sex,
                            plan_diseases: data.plan_diseases,
                            fact_diseases: data.fact_diseases,
                            plan_surgeries: data.plan_surgeries,
                            surgeries: data.plan_surgeries.map(p => p.label).join(`;`),
                            fact_surgeries: data.fact_surgeries,
                            surgery_items: data.surgery_items, // 拟施手术 Table展现形式
                            fact_surgery_items: data.fact_surgery_items, // 已施手术 Table展现形式
                            // 获取计划手术医生
                            plan_surgeon: data.plan_surgeon,
                            plan_surgeon_assistants: data.plan_surgeon_assistants,
                            plan_anes_doctor: data.plan_anes_doctor,
                            plan_anes_assistants: data.plan_anes_assistants,
                            plan_circuit_nurse: data.plan_circuit_nurse,
                            plan_equipment_nurse: data.plan_equipment_nurse,
                            // 获取实际手术医生
                            fact_surgeon: data.fact_surgeon,
                            fact_surgeon_assistants: data.fact_surgeon_assistants,
                            fact_anes_doctor: data.fact_anes_doctor,
                            fact_anes_assistants: data.fact_anes_assistants,
                            fact_circuit_nurse: data.fact_circuit_nurse,
                            fact_equipment_nurse: data.fact_equipment_nurse,
                            fact_anaes_methods: (data.fact_anaes_methods && data.fact_anaes_methods.map(d => d.value)) || (data.plan_anaes_methods && data.plan_anaes_methods.map(d => d.value)),
                            surgical_site: data.surgical_site,
                            visit_info: data.visit_info,
                            source_hospital_ward_id: data.source_hospital_ward_id
                        },
                        datas
                    )
                    if (_.findIndex(obj.fact_surgery_items, { is_empty: true }) == -1) {
                        obj.fact_surgery_items.push({ is_empty: true })
                    }
                    // getone的时候把动态列字段放到obj对象里面
                    if (this.extendColumnList) {
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, obj, data)
                    }
                    this.surgeryInfo = obj
                    if (obj.enum_outoperatingroomtype) {
                        this.enum_businesstype = obj.enum_outoperatingroomtype
                        this.loadBusinessConfig().catch(e => console.log(e))
                    }
                    this.oldSurgeryInfo = _.cloneDeep(this.surgeryInfo)
                    if (data.is_local_anes) this.showDatetime = true
                    resolve(this.surgeryInfo)
                }).catch(e => {
                    console.log(e, 1)
                    reject(e)
                })
            })
        },
        putOne(data) {
            // ACIS-25406 处理实际手术名称可能和字典不一样
            let factsurgeryname = data.fact_surgeries && data.fact_surgeries.map(d => d.label)
            let summaryname = factsurgeryname && factsurgeryname.length > 0 ? factsurgeryname.join(`,`) : ``
            let changeSummary = {
                biz_surgery_info_id: data.id,
                surgery: summaryname,
                is_fasting: true
            }
            let obj = {
                id: data.id,
                plan_time: data.plan_time,
                infectious: data.infectious && data.infectious.join(`,`),
                is_fasting: data.is_fasting,
                remark: data.remark,
                enum_asa: data.enum_asa,
                enum_surgery_scale: data.enum_surgery_scale,
                enum_cut_level: data.enum_cut_level,
                enum_surgery_type: data.enum_surgery_type,
                enum_out_room_destination: data.enum_out_room_destination,
                enum_outoperatingroomtype: data.enum_outoperatingroomtype,
                dic_section_id: data.dic_section_id,
                dic_operating_room_id: data.dic_operating_room_id,
                dic_operating_ward_id: data.dic_operating_ward_id,
                visit_info: {
                    age: data.age,
                    height: data.height,
                    weight: data.weight,
                    bed_no: data.bed_no,
                    visit_no: data.visit_no,
                    outpatient_no: data.outpatient_no,
                    visit_time: data.visit_time,
                    phone: data.phone,
                    address: data.address,
                    enum_visit_type: data.enum_visit_type,
                    enum_pay_type: data.enum_pay_type,
                    name: data.name,
                    birthday: data.birthday,
                    card_type: data.card_type,
                    card_no: data.card_no,
                    insurance_no: data.insurance_no,
                    enum_blood_type: data.enum_blood_type,
                    enum_rh_blood_type: data.enum_rh_blood_type,
                    enum_sex: data.enum_sex
                },

                fact_diseases: data.fact_diseases.map(d => d.value),
                fact_surgeries: data.fact_surgeries.map(d => d.value),
                plan_diseases: data.plan_diseases.map(d => d.value),
                plan_surgeries: data.plan_surgeries.map(d => d.value),

                plan_surgeon: !data.plan_surgeon ? -1 : data.plan_surgeon.value,
                plan_surgeon_assistants: data.plan_surgeon_assistants && data.plan_surgeon_assistants.map(d => d.value),
                plan_anes_doctor: !data.plan_anes_doctor ? -1 : data.plan_anes_doctor.value,
                plan_anes_assistants: data.plan_anes_assistants && data.plan_anes_assistants.map(d => d.value),
                plan_circuit_nurse: data.plan_circuit_nurse && data.plan_circuit_nurse.map(d => d.value),
                plan_equipment_nurse: data.plan_equipment_nurse && data.plan_equipment_nurse.map(d => d.value),

                fact_surgeon: !data.fact_surgeon ? -1 : data.fact_surgeon.value,
                fact_surgeon_assistants: data.fact_surgeon_assistants && data.fact_surgeon_assistants.map(d => d.value),
                fact_anes_doctor: !data.fact_anes_doctor ? -1 : data.fact_anes_doctor.value,
                fact_anes_assistants: data.fact_anes_assistants && data.fact_anes_assistants.map(d => d.value),
                fact_circuit_nurse: data.fact_circuit_nurse && data.fact_circuit_nurse.map(d => d.value),
                fact_equipment_nurse: data.fact_equipment_nurse && data.fact_equipment_nurse.map(d => d.value),
                fact_anaes_methods: data.fact_anaes_methods,
                surgical_site: data.surgical_site,
                change_summary_surgery: changeSummary,
                fromPage: `localAnes`,
                source_hospital_ward_id: data.source_hospital_ward_id,
                enum_surgery_status: data.enum_surgery_status,
                fact_surgery_items: _.filter(data.fact_surgery_items, function(u) {
                    return u.is_empty == undefined || u.is_empty == false
                })
            }
            // 修改的时候把动态列字段放到obj.extra_datas对象里面
            if (this.extendColumnList) {
                this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(this.extendColumnList, obj, data)
            }
            if (obj.extra_datas) {
                let tmp = [
                    { DataKey: `plan_emergency_remark`, DataValue: data.plan_emergency_remark },
                    { DataKey: `surgery_position`, DataValue: data.surgery_position },
                    { DataKey: `inductive_effect`, DataValue: data.inductive_effect },
                    { DataKey: `inductive_complication`, DataValue: data.inductive_complication },
                    { DataKey: `drug_before_anes`, DataValue: data.drug_before_anes }
                ]
                obj.extra_datas = obj.extra_datas.concat(tmp)
            } else {
                obj.extra_datas = [
                    { DataKey: `plan_emergency_remark`, DataValue: data.plan_emergency_remark },
                    { DataKey: `surgery_position`, DataValue: data.surgery_position },
                    { DataKey: `inductive_effect`, DataValue: data.inductive_effect },
                    { DataKey: `inductive_complication`, DataValue: data.inductive_complication },
                    { DataKey: `drug_before_anes`, DataValue: data.drug_before_anes }
                ]
            }
            let req = this.myaxios.put(`/api/Preoperative/Apply/PutAfterSurgery`, obj)
            req.then(result => {
                let tmpSurgeryInfo = { ...data }
                tmpSurgeryInfo.save = true
                this.$emit(`changeSurgeInfo`, tmpSurgeryInfo)
                this.$message.success(`保存成功`)
                if (this.surgeryInfo.enum_surgery_status >= 30 && this.IsHavePermission(this.factSurgeryShowPermission)) {
                    this.savePlayedSurgery(data, false)
                }
            }).catch(
                e => {
                    if (e.data.detail == `手术状态已更新，请重新操作`) {
                        this.loadOne().then(data => {
                            data.save = true
                            this.$emit(`changeSurgeInfo`, data)
                        })
                    }
                }
            )
        },
        saveSurgeryInfo() {
            this.$refs[`surgery-info`].confirm()
        },
        changetime(newtime) {
            this.czevent.event.occurdt = newtime
            this.czevent.event.occur_time = newtime
            this.saveBusinessOccurEventbody(this.czevent.index, this.czevent)
        },
        saveOccurEvent(index, item) {
            var firstEvent = this.localAnesConfig[0] && this.localAnesConfig[0].event
            if (index != 0 && firstEvent && (!firstEvent.occur_time || firstEvent.occur_time == ``)) {
                this.$message.error(`患者尚未${this.localAnesConfig[0].label},请先执行该事件`)
                return
            }
            if (!item.event.occurdt) {
                item.event.occurdt = this.$moment().format(`YYYY/MM/DD HH:mm`)
            }
            if (this.isAllowAdjustKeyEvent == `0`) {
                item.event.occurdt = this.$moment().format(`YYYY/MM/DD HH:mm`)
                this.timeInfo.dialogFormVisible = true
                this.timeInfo.timedata = item.event.occurdt
                this.czevent = item
                this.czevent.index = index
                return
            }
            this.saveBusinessOccurEventbody(index, item)
        },
        saveBusinessOccurEventbody(index, item) {
            let inputModel = {
                id: this.surgeryId,
                visit_info: this.surgeryInfo.visit_info,
                enum_out_room_destination: this.$refs[`surgery-info`].formdata && this.$refs[`surgery-info`].formdata.enum_out_room_destination,
                enum_outoperatingroomtype: this.$refs[`surgery-info`].formdata && this.$refs[`surgery-info`].formdata.enum_outoperatingroomtype
            }
            let that = this
            if (index == 0) {
                let startBusinessAnesModel = {}
                startBusinessAnesModel.surgeryInfoModel = inputModel
                startBusinessAnesModel.eventUsageModel = item.event
                let req = this.myaxios.post(`/api/OtherBusiness/BusinessOccurEvent/StartBusinessAnesAllThings?surgeryId=${this.surgeryId}`, startBusinessAnesModel)
                req.then(data => {
                    this.init().then(data => {
                        let tmpSurgeryInfo = { ...data }
                        tmpSurgeryInfo.surgery_status = _.filter(this.sys_enums.SurgeryStatus, { value: tmpSurgeryInfo.enum_surgery_status })[0].label
                        tmpSurgeryInfo.save = true
                        if (this.isAllowAdjustKeyEvent == `0`) {
                            this.timeInfo.dialogFormVisible = false
                            this.timeInfo.timedata = null
                        }
                        this.$emit(`changeSurgeInfo`, tmpSurgeryInfo)
                    }).catch(e => {
                        console.log(e)
                        this.$message.error(e)
                    })
                    this.$message.success(item.label)
                })
            } else if (index == this.localAnesConfig.length - 1) {
                let startBusinessAnesModel = {}
                startBusinessAnesModel.surgeryInfoModel = inputModel
                startBusinessAnesModel.eventUsageModel = item.event
                let req = this.myaxios.post(`/api/OtherBusiness/BusinessOccurEvent/EndBusinessAnesAllThings?surgeryId=${this.surgeryId}`, startBusinessAnesModel)
                req.then(data => {
                    this.$message.success(item.label)
                    this.init().then(data => {
                        let tmpSurgeryInfo = { ...data }
                        tmpSurgeryInfo.surgery_status = _.filter(this.sys_enums.SurgeryStatus, { value: tmpSurgeryInfo.enum_surgery_status })[0].label
                        if (this.isAllowAdjustKeyEvent == `0`) {
                            this.timeInfo.dialogFormVisible = false
                            this.timeInfo.timedata = null
                        }
                        this.$emit(`changeSurgeInfo`, tmpSurgeryInfo)
                    }).catch(e => {
                        console.log(e)
                        this.$message.error(e)
                    })
                }).catch((action) => {
                    this.init().then(data => { })
                })
            } else {
                that.myaxios[item.event.id ? `put` : `post`](`/api/OtherBusiness/BusinessOccurEvent/${item.event.id ? `PutOccurEvent` : `PostOccurEvent`}`, item.event)
                    .then(data => {
                        let msg = item.event.id ? `修改` : `添加`
                        this.$message.success(msg + `‘` + item.label + `’` + `事件成功`)
                        this.loadOne()
                    }).catch((action) => {
                        this.loadOne().then(data => { })
                    })
            }
        },
        cancelLocalAnesSurgery() {
            this.$confirm(`数据会被清空, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `danger`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.post(`/api/OtherBusiness/BusinessOccurEvent/CancelSurgery?surgeryId=${this.surgeryId}`)
                req.then(data => {
                    this.init().then(data => {
                        let tmpSurgeryInfo = { ...data }
                        tmpSurgeryInfo.surgery_status = _.filter(this.sys_enums.SurgeryStatus, { value: tmpSurgeryInfo.enum_surgery_status })[0].label
                        tmpSurgeryInfo.save = true
                        this.$emit(`changeSurgeInfo`, tmpSurgeryInfo)
                    }).catch(e => {
                        console.log(e)
                    })
                })
            })
        },
        loadingOverruleView() {
            this.$confirm(`提示`, {
                title: `提示`,
                message: `确定要终止手术吗？是否继续?`,
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.overrule.dialogFormVisible = true
                    this.overrule.surgeryId = this.surgeryId
                })
                .catch(e => {
                    console.log(e)
                })
        },
        saveOverrule(row) {
            let that = this
            let req = that.myaxios.put(`/api/Intraoperative/Anaesthesia/CancelOperation/${that.overrule.surgeryId}?reason=${row.term_reason}`)
            req.then(data => {
                that.init().then(data => {
                    let tmpSurgeryInfo = { ...data }
                    tmpSurgeryInfo.surgery_status = _.filter(that.sys_enums.SurgeryStatus, { value: tmpSurgeryInfo.enum_surgery_status })[0].label
                    tmpSurgeryInfo.save = true
                    that.overrule.dialogFormVisible = false
                    that.$emit(`changeSurgeInfo`, tmpSurgeryInfo)
                }).catch(e => {
                    console.log(e)
                })
            }).catch(e => {})
        },
        loadMergedPatientData() {
            this.mergedRow = { ...this.surgeryInfo }
            this.mergeApplyList.dialogFormVisible = true
        },
        activTargetRow({ row }) {
            this.merged_target_row = row
        },
        cancelMerge() {
            this.mergeApplyList.dialogFormVisible = false
        },
        merged() {
            let surgeryDone = this.mergedRow && this.mergedRow.id
            let hisSurgeryId = this.merged_target_row && this.merged_target_row.id
            if (surgeryDone === undefined || hisSurgeryId === undefined) {
                this.$message.warning(`未选择需要合并的患者`)
                return
            }
            let that = this
            this.$confirm(`确定与"${that.merged_target_row.patient_name},${that.merged_target_row.visit_no}"合并信息？合并后将无法撤销`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.post(`/api/Preoperative/Apply/MergeSurgery?surgeryDone=${surgeryDone}&hisSurgeryId=${hisSurgeryId}`)
                req.then(data => {
                    that.init().then(data => {
                        let tmpSurgeryInfo = { ...data }
                        tmpSurgeryInfo.save = true
                        this.$emit(`changeSurgeInfo`, tmpSurgeryInfo)
                    }).catch(e => {
                        console.log(e)
                    })
                    that.mergeApplyList.dialogFormVisible = false
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        playedsurgeryInfoSaveSueryInfo() {
            this.savetitle = `已施手术`
            this.$refs[`played-surgery-info`].confirm()
        },
        savePlayedSurgery(data, errorAlert = true) {
            let that = this
            let showMode = this.showModifySurgeryMode
            try {
                var pddata = _.filter(data.fact_surgery_items, function(u) {
                    return u.is_empty == undefined || u.is_empty == false
                })
                if (errorAlert) {
                    let showColumns = []
                    if (this.$refs[`played-surgery-info`]) {
                        showColumns = this.$refs[`played-surgery-info`].columns[0].options
                    }
                    pddata.forEach(d => {
                        if (d.plan_surgeries == null) {
                            this.$message.error(`请选择手术名称！`)
                            throw new Error(`EndIterative`)
                        }
                        if (showMode == 2 && (d.plan_surgeries_name == null || d.plan_surgeries_name == ``)) {
                            this.$message.error(`请录入实际手术名称！`)
                            throw new Error(`EndIterative`)
                        }

                        if (d.plan_surgery_scale == null && showColumns.findIndex(item => item.label == `手术等级`) > -1 && that.required.indexOf(`手术等级`) > -1) {
                            this.$message.error(`请选择手术等级！`)
                            throw new Error(`EndIterative`)
                        }
                        if (d.plan_enum_cut_level == null && showColumns.findIndex(item => item.label == `切口等级`) > -1 && that.required.indexOf(`切口等级`) > -1) {
                            this.$message.error(`请选择切口等级！`)
                            throw new Error(`EndIterative`)
                        }
                        if (d.plan_surgery_region == null && showColumns.findIndex(item => item.label == `部位`) > -1 && that.required.indexOf(`部位`) > -1) {
                            this.$message.error(`请选择部位！`)
                            throw new Error(`EndIterative`)
                        }

                        if (d.plan_anaes_method == null && showColumns.findIndex(item => item.label == `麻醉方式`) > -1 && that.required.indexOf(`麻醉方式`) > -1) {
                            this.$message.error(`请选择麻醉方式！`)
                            throw new Error(`EndIterative`)
                        }

                        if (d.plan_surgery_position == null && showColumns.findIndex(item => item.label == `体位`) > -1 && that.required.indexOf(`体位`) > -1) {
                            this.$message.error(`请选择体位！`)
                            throw new Error(`EndIterative`)
                        }
                    })

                    let r = _.groupBy(pddata, d => d.plan_surgeries.value)
                    _.forEach(r, (g) => {
                        if (g.length > 1) {
                            this.$message.error(`手术名称重复`)
                            throw new Error(`EndIterative`)
                        }
                    })
                }
            } catch (e) {
                if (e.message != `EndIterative`) throw e
                return
            }
            if (data.id > 0) {
                let factsurgeryname = []
                let factItems = _.filter(data.fact_surgery_items, function(u) {
                    return u.is_empty == undefined || u.is_empty == false
                }).map(d => {
                    let s = {
                        plan_surgeries: d.plan_surgeries.value,
                        plan_surgery_scale: d.plan_surgery_scale,
                        plan_enum_cut_level: d.plan_enum_cut_level,
                        plan_surgery_region: d.plan_surgery_region,
                        plan_surgery_position: d.plan_surgery_position,
                        plan_anaes_method: d.plan_anaes_method,
                        prefix_name: d.prefix_name,
                        behind_name: d.behind_name
                    }
                    if (showMode == 2) {
                        factsurgeryname.push(d.plan_surgeries_name)
                    }
                    return s
                })
                // let planItems = _.filter(data.surgery_items, function(u) {
                //     return u.is_empty == undefined || u.is_empty == false
                // }).map(d => {
                //     let s = {
                //         plan_surgeries: d.plan_surgeries.value,
                //         plan_surgery_scale: d.plan_surgery_scale,
                //         plan_enum_cut_level: d.plan_enum_cut_level,
                //         plan_surgery_region: d.plan_surgery_region,
                //         plan_surgery_position: d.plan_surgery_position,
                //         plan_anaes_method: d.plan_anaes_method,
                //         prefix_name: d.prefix_name,
                //         behind_name: d.behind_name
                //     }
                //     return s
                // })
                let obj = {
                    id: data.id,
                    fact_surgery_items: factItems,
                    surgery_items: null
                }

                // 处理实际手术名称可能和字典不一样
                if (showMode == 2) {
                    let summaryname = factsurgeryname && factsurgeryname.length > 0 ? factsurgeryname.join(`,`) : ``
                    let changeSummary = {
                        biz_surgery_info_id: data.id,
                        surgery: summaryname,
                        is_fasting: true
                    }
                    obj.change_summary_surgery = changeSummary
                }

                let req = this.myaxios.put(`/api/Preoperative/Apply/SavePlayedSurgery`, obj)
                let reqs2 = _.map(this.removeItems, d => {
                    return this.myaxios.delete(`/api/Preoperative/Apply/DeleteArrangeSurgery?arrangeSurgeryId=${d.id}`)
                })
                req = reqs2.concat(req)
                return new Promise((resolve, reject) => {
                    this.myaxios
                        .all(...req).then(res => {
                            if (errorAlert) {
                                this.$message.success(`${this.savetitle}保存成功`)
                            }
                            this.loadOne()
                            resolve(res)
                        }).catch((e) => reject(e))
                })
            }
        },
        removeItem(index) {
            let row = this.surgeryInfo.fact_surgery_items.splice(index, 1)[0]
            if (row.id) {
                this.removeItems.push(row)
            }
        },
        ExtraButtonClick({ emit, row, index }) {
            if (emit == `removeItem`) {
                this.removeItem(index)
            }
        },
        timeForm(time) {
            console.log(time)

            let now = new Date(this.$moment(time).format(`YYYY/MM/DD HH:mm`))
            console.log(now)
            let year = now.getFullYear()
            let month = now.getMonth() + 1
            month = month < 10 ? `0` + month : month
            let day = now.getDate()
            day = day < 10 ? `0` + day : day
            let hour = now.getHours()
            hour = hour < 10 ? `0` + hour : hour
            let min = now.getMinutes()
            min = min < 10 ? `0` + min : min
            let timeValue = year + `-` + month + `-` + day + `T` + hour + `:` + min
            return timeValue
        },
        checkDataChangeAndPrompt() {
            let that = this
            that.dataChanged = false
            if (that.surgeryId > 0) {
                that.dataChanged = !that.$surgeryInfoExtraParamUtil.objectsAreEqual(that.surgeryInfo, this.$refs[`surgery-info`].formdata)
                if (that.dataChanged === false) {
                    console.log(`old`, that.oldSurgeryInfo.fact_surgery_items)
                    console.log(`new`, that.$refs[`played-surgery-info`].formdata.fact_surgery_items)

                    let olditems = _.cloneDeep(that.oldSurgeryInfo.fact_surgery_items)
                    // 判断是否有新增的行.
                    var checkAdd = _.filter(that.$refs[`played-surgery-info`].formdata.fact_surgery_items, function(u) {
                        return u.is_empty == false && u.plan_surgeries_name != ``
                    })
                    console.log(`checkAdd`, checkAdd)
                    if (checkAdd && checkAdd.length > 0) {
                        that.dataChanged = true
                    }
                    // 判断是否有修改的行
                    var checkEdit = _.filter(that.$refs[`played-surgery-info`].formdata.fact_surgery_items, function(u) {
                        return u.id > 0
                    })
                    if (checkEdit && checkEdit.length > 0) {
                        for (let i = 0; i < checkEdit.length; i++) {
                            let oldline = _.find(olditems, { id: checkEdit[i].id })
                            console.log(`oldline`, oldline)
                            that.dataChanged = !that.$surgeryInfoExtraParamUtil.objectsAreEqual(oldline, checkEdit[i])
                            console.log(`that.dataChanged `, that.dataChanged)
                            if (that.dataChanged === true) {
                                break
                            }
                        }
                    }
                }

                // alert(`数据已变动，确定要离开吗？`)
                return that.dataChanged
            }
        },
        // 事件方法
        getReload() {
            this.reload() // 重置刷新
        }
    },
    inject: [`reload`],
    watch: {
        $route: function(newUrl, oldUrl) {
            this.getReload()
        },
        rdate1: function() {
            this.$refs[`merge-list`].ReloadListData()
        }
    }
}
</script>
<style scoped lang="less">
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}

.playedsurgery /deep/ .cus-form .el-form-item.left .el-form-item__content {
    margin-left: 0px;
}

.theme-dark .el-input__inner,
.theme-his-blue .el-input__inner {
    height: 32px !important;
}
</style>
<style lang="less">
.local-anesthesia {
    .title1 p {
        background: lightgray;
        font-size: 20px;
    }
    .title2 p {
        background: lightgray;
        font-size: 20px;
    }
    .local-anesthesia-date .el-date-editor {
        &.el-input--suffix .el-input__inner {
            padding-right: 10px !important;
        }
        &.el-input--prefix .el-input__inner {
            padding-left: 10px !important;
        }
        .el-input__suffix {
            display: none;
        }
        .el-input__prefix {
            display: none;
        }
        input {
            text-align: center;
        }
    }
}

.inputlocal {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 2px 0px 2px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 175px;
    height: 32px;
    margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/OutRoomAnes/Index.vue